<template>
    <div>
        <h3>Ceci est le composant du <em>Compositeur</em>, mais il n'est pas encore écrit.</h3>
    </div>
</template>

<script>
export default {
    name: 'Compositeur',
    props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
    font-size: 2em;
    text-align:center;
    color:red;
}
</style>
